<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditForm"
        :model="dialogAddEditForm"
        :rules="dialogAddEditFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="店名"
                  prop="storeName"
                >
                  <el-input
                    v-model="dialogAddEditForm.storeName"
                    maxlength="64"
                    placeholder="请输入店名"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="地址"
                  prop="address"
                >
                  <el-input
                    v-model="dialogAddEditForm.address"
                    maxlength="256"
                    placeholder="请输入地址"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="终端业态"
                  prop="storeType"
                >
                  <el-select
                    v-model="dialogAddEditForm.storeType"
                    filterable
                    clearable
                    placeholder="请选择终端业态"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in storeTypeOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogAddEditForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属城市"
                  prop="cityId"
                >
                  <el-select
                    v-model="dialogAddEditForm.cityId"
                    filterable
                    clearable
                    placeholder="请选择城市"
                    style="width:100%"
                    @change="handleCityChange"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="所属区县"
                  prop="countyId"
                >
                  <el-select
                    v-model="dialogAddEditForm.countyId"
                    filterable
                    clearable
                    placeholder="请选择区县"
                    style="width:100%"
                    @change="handleCountyChange"
                  >
                    <el-option
                      v-for="item in countyOptions"
                      :key="item.label"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="维护人"
                  prop="manageUserIds"
                >
                  <el-select
                    v-if="eventType === 'add'"
                    v-model="dialogAddEditForm.manageUserIds"
                    filterable
                    clearable
                    multiple
                    placeholder="请选择维护人"
                    style="width:100%"
                    @change="changeManageUserFun"
                  >
                    <el-option
                      v-for="item in manageUserOptions"
                      :key="item.data"
                      :label="item.label"
                      :value="item.data"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditForm.manageUserName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="是否销售卷烟"
                  required
                >
                  <el-radio-group
                    v-model="dialogAddEditForm.isSellTobacco"
                    @change="(val) => { if(val === 0) { dialogAddEditForm.cigaretteBusiness = ''} }"
                  >
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="0">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col
                v-if="dialogAddEditForm.isSellTobacco === 1"
                :span="6"
              >
                <el-form-item label="卷烟经营类型">
                  <el-select
                    v-model="dialogAddEditForm.cigaretteBusiness"
                    filterable
                    clearable
                    placeholder="请选择卷烟经营类型"
                    style="width:100%"
                  >
                    <el-option
                      label="零售"
                      :value="1"
                    />
                    <el-option
                      label="批发"
                      :value="2"
                    />
                    <el-option
                      label="批零兼营"
                      :value="3"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="modal-box">
          <h3 class="modal-title">
            联系信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="联系人"
                  prop="ownerName"
                >
                  <el-input
                    v-model="dialogAddEditForm.ownerName"
                    placeholder="请输入联系人"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="性别">
                  <el-radio-group v-model="dialogAddEditForm.gender">
                    <el-radio
                      v-for="(item) in genderOptions"
                      :key="item.data"
                      :label="item.data"
                    >
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系电话"
                  prop="phone"
                >
                  <el-input
                    v-model="dialogAddEditForm.phone"
                    placeholder="请输入联系电话"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="联系人1"
                  prop="linkman1"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman1"
                    placeholder="请输入联系人1"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人1与联系人关系"
                  prop="linkman1Relation"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman1Relation"
                    placeholder="请输入联系人1与联系人关系"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人1电话"
                  prop="linkman1Phone"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman1Phone"
                    placeholder="请输入联系人1电话"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="联系人2"
                  prop="linkman2"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman2"
                    placeholder="请输入联系人2"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人2与联系人关系"
                  prop="linkman2Relation"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman2Relation"
                    placeholder="请输入联系人2与联系人关系"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="联系人2电话"
                  prop="linkman2Phone"
                >
                  <el-input
                    v-model="dialogAddEditForm.linkman2Phone"
                    placeholder="请输入联系人2电话"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <upload-image
          ref="upload-special-store-image"
          :file-list.sync="imageFileList"
          :directory="directory"
          :max-size="10"
          :limit="9"
        />

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditForm.remark"
                    type="textarea"
                    placeholder="备注"
                    maxlength="128"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// dialog拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
import { getToken } from "@/utils/auth"
// 图片上传组件
import uploadImage from '@/components/UploadImage'
// 零售户档案API
import { saveStoreInfoApi, viewStoreInfoApi } from '@/api/v2/store';
// 区域API
import { listAreaApi } from '@/api/v2/area';
// 数据字典API
import { listDictApi } from '@/api/v2/dict';
// 用户API
import { loadUserSelectDataByUserTypeApi } from '@/api/user'

export default {
  components: { uploadImage },
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        storeName: [{ required: true, message: '请输入店名', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择所属城市', trigger: 'change' }],
        countyId: [{ required: true, message: '请选择所属区县', trigger: 'change' }],
        cigaretteBusiness: [{ required: true, message: '请选择卷烟经营类型', trigger: 'change' }],
        storeType: [{ required: true, message: '请选择终端业态', trigger: 'change' }],
        manageUserIds: [{ required: true, message: '请选择维护人', trigger: 'change' }],
        ownerName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        phone: [{ max: 32, message: '最多输入32个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      provinceOptions: [],
      cityOptions: [],
      countyOptions: [],
      storeTypeOptions: [],
      cigaretteBusinessDataList: [],
      manageUserOptions: [],
      genderOptions: [{ label: '男', data: 1 }, { label: '女', data: 2 }],
      directory: 'specialStoreInfo',
      // 照片对象数组
      imageFileList: [],
      baseUrl: process.env.VUE_APP_FILE_V2_API
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;
        _this.provinceOptions = []
        _this.cityOptions = []
        _this.countyOptions = []
        _this.storeTypeOptions = []
        _this.manageUserOptions = []
        _this.imageFileList = []
        _this.dialogAddEditForm = {
          storeName: '',
          address: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          countyId: '',
          countyName: '',
          storeType: '',
          manageUserIds: [],
          manageUserId: '',
          manageUserName: '',
          isSellTobacco: 1,
          cigaretteBusiness: '',
          ownerName: '',
          gender: 1,
          phone: '',
          linkman1: '',
          linkman1Relation: '',
          linkman1Phone: '',
          linkman2: '',
          linkman2Relation: '',
          linkman2Phone: '',
          remark: '',
          billType: 2
        }
        _this.loadProvinceDataList()
        _this.loadStoreTypeData()
        _this.initManageUserSelectData()
        if (_this.eventType !== 'add') {
          _this.loadStoreData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    // 获取省区数据
    loadProvinceDataList () {
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择省区回调
    handleProvinceChange (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.provinceName = selectItem ? selectItem.label : ''
      _this.cityOptions = []
      _this.countyOptions = []
      _this.dialogAddEditForm.cityName = ''
      _this.dialogAddEditForm.cityId = null
      _this.dialogAddEditForm.countyName = ''
      _this.dialogAddEditForm.countyId = null
      _this.loadCityDataList(val)
    },
    // 获取城市数据
    loadCityDataList (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.cityOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择城市回调
    handleCityChange (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.cityOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.cityName = selectItem ? selectItem.label : ''
      _this.countyOptions = []
      _this.dialogAddEditForm.countyName = ''
      _this.dialogAddEditForm.countyId = null
      _this.loadCountyDataList(val)
    },
    // 获取区县数据
    loadCountyDataList (val) {
      listAreaApi({ parentId: val, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.countyOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 选择区县回调
    handleCountyChange (val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.countyOptions.find(item => {
        return item.data === val
      })
      _this.dialogAddEditForm.countyName = selectItem ? selectItem.label : ''
    },
    // 获取终端业态下拉数据
    loadStoreTypeData () {
      listDictApi({ type: 34 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          this.storeTypeOptions.push({ label: item.optionLabel, data: item.optionValue })
        })
      })
    },
    // 初始维护人下拉数据
    initManageUserSelectData () {
      loadUserSelectDataByUserTypeApi().then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.manageUserOptions.push({ label: item.name, data: item.id })
        })
      })
    },
    // 维护人回调
    changeManageUserFun (val) {
      let _this = this;
      let userNames = ''
      let userIds = ''
      val.forEach(idItem => {
        let selectItem = {}
        selectItem = _this.manageUserOptions.find(item => {
          return item.data === idItem
        })
        if (selectItem) {
          userNames += ',' + selectItem.label
          userIds += ',' + selectItem.data
        }
      })
      if (userNames.length > 0) {
        _this.dialogAddEditForm.manageUserName = userNames.substring(1)
        _this.dialogAddEditForm.manageUserId = userIds.substring(1)
      } else {
        _this.dialogAddEditForm.manageUserName = ''
        _this.dialogAddEditForm.manageUserId = ''
      }
    },
    // 获取特殊终端数据
    loadStoreData () {
      let _this = this;
      viewStoreInfoApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        for (let key in _this.dialogAddEditForm) {
          if (key !== 'checkedTypes' && key !== 'checkedTags' && key !== 'manageUserIds') {
            _this.dialogAddEditForm[key] = data[key]
          }
        }
        _this.dialogAddEditForm.cigaretteBusiness = data.cigaretteBusiness || '';
        _this.dialogAddEditForm.manageUserIds = data.manageUserId.split(',')
        _this.dialogAddEditForm.id = data.id

        _this.loadCityDataList(data.provinceId)
        _this.loadCountyDataList(data.cityId)

        // 处理照片清单
        if (data.attachmentInfoDtoList && data.attachmentInfoDtoList.length > 0) {
          data.attachmentInfoDtoList.forEach((item) => {
            _this.imageFileList.push({
              name: item.attachmentName,
              url: _this.baseUrl + item.attachmentUrl,
              baseUrl: item.attachmentUrl,
            })
          })
        }
      })
    },

    // 新增|修改保存
    handleSave () {
      let _this = this;
      _this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '特殊终端', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            let picUrls = []
            let picNames = []
            _this.imageFileList.forEach(item => {
              picUrls.push(item.baseUrl)
              picNames.push(item.name)
            })
            _this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
            _this.dialogAddEditForm.picNames = JSON.stringify(picNames)
            _this.dialogAddEditForm.realStoreName = _this.dialogAddEditForm.storeName
            _this.dialogAddEditForm.realAddress = _this.dialogAddEditForm.address
            saveStoreInfoApi(_this.dialogAddEditForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditForm.clearValidate()
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
